// ui/src/api/trading.js
// ---------------------
// API client helpers for trading simulation endpoints.

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

/**
 * Run trading simulations for specified scenarios.
 * @param {string[]} scenarios - Scenario names (e.g., "aggressive-low")
 * @param {number} months_back - Number of months to backtest
 * @returns {Promise<{status, simulations}>}
 */
export async function runSimulation(scenarios, months_back = 6) {
  const response = await fetch(`${API_URL}/trading/simulate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ scenarios, months_back }),
  });

  if (!response.ok) {
    throw new Error(`Trading simulation failed: ${response.statusText}`);
  }

  return response.json();
}

/**
 * Get list of available simulation scenarios.
 * @returns {Promise<{status, scenarios}>}
 */
export async function listScenarios() {
  const response = await fetch(`${API_URL}/trading/scenarios`);

  if (!response.ok) {
    throw new Error(`Failed to fetch scenarios: ${response.statusText}`);
  }

  return response.json();
}
